import Vue from 'vue'
import Router from 'vue-router'
import AssignmentTermsDashboard from '@/components/AssignmentTermsDashboard'
import AffiliatedGroupsList from '@/components/AffiliatedGroupsList'
import AssignmentTermsExport from '@/components/AssignmentTermsExport'
import ProductCoverageExport from '@/components/ProductCoverageExport'
import RemainingContingentsExport from '@/components/RemainingContingentsExport'
import AffiliatedGroupDetails from '@/components/AffiliatedGroupDetails'
import Login from '@/components/login'
import InsufficientPermissionsPage from '@/components/InsufficientPermissionsPage'
import store from '@/store'
import OptionIdsMaintenance from '@/components/AdminPanel/OptionIdsMaintenance'
import ZipcodesManagement from '@/components/AdminPanel/ZipcodesManagement'
import { buildInternalAdminVendorProductUrl } from '@/helpers/internalAdminLinks'

Vue.use(Router)

const ifNotAuthenticated = (to, from, next) => {
  if (!store.getters.isAuthenticated) {
    next()
    return
  }
  next('/')
}

const ifAuthenticated = (to, from, next) => {
  if (store.getters.isAuthenticated) {
    next()
    return
  }
  next('/login')
}

const redirectToInternalAdminAssignmentTerms = (to) => {
  window.location.replace(
    buildInternalAdminVendorProductUrl(
      to.params.vendorId,
      to.params.productId,
      to.query.at_id
    )
  )
}

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'AssignmentTermsDashboard',
      component: AssignmentTermsDashboard,
      beforeEnter: ifAuthenticated,
      meta: { requiresAuth: true }
    },
    {
      path: '/vendors/:vendorId/products/:productId/assignment_terms',
      name: 'AssignmentTermsList',
      // Vue Router still requires a component; navigation never settles (external replace).
      component: { render: h => h() },
      beforeEnter: redirectToInternalAdminAssignmentTerms,
      meta: { requiresAuth: false }
    },
    {
      path: '/affiliated_groups',
      name: 'AffiliatedGroups',
      component: AffiliatedGroupsList,
      beforeEnter: ifAuthenticated,
      meta: { requiresAuth: true }
    },
    {
      path: '/assignment_terms_export',
      name: 'AssignmentTermsExport',
      component: AssignmentTermsExport,
      beforeEnter: ifAuthenticated,
      meta: { requiresAuth: true }
    },
    {
      path: '/coverage_export',
      name: 'ProductCoverageExport',
      component: ProductCoverageExport,
      beforeEnter: ifAuthenticated,
      meta: { requiresAuth: true }
    },
    {
      path: '/remaining_contingents_export',
      name: 'RemainingContingentsExport',
      component: RemainingContingentsExport,
      beforeEnter: ifAuthenticated,
      meta: { requiresAuth: true }
    },
    {
      path: '/affiliated_groups/:id',
      name: 'AffiliatedGroupDetails',
      component: AffiliatedGroupDetails,
      beforeEnter: ifAuthenticated,
      meta: { requiresAuth: true }
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      beforeEnter: ifNotAuthenticated,
      meta: { requiresAuth: false }
    },
    {
      path: '/no_access',
      name: 'InsufficientPermissionsPage',
      component: InsufficientPermissionsPage,
      beforeEnter: ifNotAuthenticated,
      meta: { requiresAuth: false }
    },
    {
      path: '/admin/option_ids',
      name: 'OptionIdsAdminPanel',
      component: OptionIdsMaintenance,
      beforeEnter: ifAuthenticated,
      meta: { requiresAuth: true }
    },
    {
      path: '/admin/zipcodes',
      name: 'ZipcodesManagement',
      component: ZipcodesManagement,
      beforeEnter: ifAuthenticated,
      meta: { requiresAuth: true }
    }
  ]
})

router.beforeEach((to, from, next) => {
  // Set the destination path in local storage so that it can be retrieved after authentication to redirect the user back to the original requested path
  if (to.meta.requiresAuth) {
    localStorage.setItem('redirectPath', to.fullPath)
  }

  document.title = to.name
  next()
})

export default router
